import { styled } from '@ghq-abi/design-system';

export const ContentBox = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: '$white',
  border: 'solid 1px #D2D2D2',
  borderRadius: '$2',
  p: '$md',
  width: '$full',

  variants: {
    noBorder: {
      true: {
        border: 'none',
      },
    },
    greyBackground: {
      true: {
        backgroundColor: '#F5F5F5',
      },
    },
    noPadding: {
      true: {
        padding: '0',
      },
    },
  },
});
